// extracted by mini-css-extract-plugin
export default {"container":"customCheck_container__Eve2G","checkmark":"customCheck_checkmark__MkUlW"};